"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.LayoutManager = void 0;
var _pixi = require("pixi.js");
var _LayoutCell = require("./LayoutCell");
var _core = require("@dragon/core");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var LayoutManager = exports.LayoutManager = /*#__PURE__*/function () {
  function LayoutManager() {
    var _this = this;
    _classCallCheck(this, LayoutManager);
    _defineProperty(this, "_cells", void 0);
    _defineProperty(this, "_rows", void 0);
    _defineProperty(this, "_columns", void 0);
    _defineProperty(this, "_widthOffset", void 0);
    _defineProperty(this, "_heightOffset", void 0);
    _defineProperty(this, "_container", void 0);
    _defineProperty(this, "_debugMode", false);
    _defineProperty(this, "getContainer", function () {
      return _this._container;
    });
    /**
     * Wont work... need to repaint stuff.
     */
    _defineProperty(this, "enableDebug", function () {
      _this._debugMode = true;
    });
    _defineProperty(this, "getColumns", function () {
      return _this._columns;
    });
    _defineProperty(this, "getRows", function () {
      return _this._rows;
    });
    this._container = new _pixi.Container();
    this._container.zIndex = 10;
    //        parentContainer.addChild(this._container);
    this._cells = [];
  }
  return _createClass(LayoutManager, [{
    key: "createGrid",
    value:
    /**
     * Creates a grid comprised of Cells that can resize and reposition objects
     * @param rows rows in the grid
     * @param columns columns in the grid
     * @param widthOffset width offset to be excluded from layout handling
     * @param heightOffset height offset to be excluded from layout handling
     */
    function createGrid(rows, columns) {
      var widthOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var heightOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      if (this._cells.length > 0) {
        throw new Error("Dynamic grid size not supported yet!");
      }
      this._rows = rows;
      this._columns = columns;

      // console.log('Rows: ' + this._rows)
      // console.log('Columns: ' + this._columns)

      this._widthOffset = widthOffset;
      this._heightOffset = heightOffset;
      var width = this.width;
      var height = this.height;

      // console.log('wid:' + width)

      for (var i = 0; i < this._rows; i++) {
        this._cells[i] = [];
        for (var j = 0; j < this._columns; j++) {
          this._cells[i].push(new _LayoutCell.LayoutCell(j + 1, i + 1, j * width, i * height, width, height, this._container, this._debugMode));
        }
      }
      //console.log(this._cells)

      _core.CORE.subscribe('config.screenSize', this.onResize.bind(this), false);
    }
  }, {
    key: "onResize",
    value: function onResize(s) {
      //  console.log('GRID RESIZE')
      if (this._cells.length > 0) {
        this.updateGrid();
      }
      /**
       * Call onResize on all components with a onResize funtion implementation.
       * Note having one is not mandetory since not all componese should resize.
       * This functions checks if the IGameComponent Implementation actually have implementeted it before it tries calling it.
       */

      for (var i = 0; i < _core.gameComponentRegistry.registery.length; i++) {
        if (typeof _core.gameComponentRegistry.registery[i].onResize == 'function') _core.gameComponentRegistry.registery[i].onResize(s);
      }
    }

    /** 
    public createGridFixed(width: number, height: number) {
        CORE.getState()
        let screen = CORE.getState().config.screenSize
          this._rows = Math.ceil(screen.height / height);
        this._columns = Math.ceil(screen.width / width);
          let offsetX = ((width - (screen.width % width)) / 2) * -1    //(screen.width%width) *-1;  
        let offsetY = ((height - (screen.height % height)) / 2) * -1
          for (let i = 0; i < this._rows; i++) {
            this._cells[i] = []
            for (let j = 0; j < this._columns; j++) {
                this._cells[i].push(new Cell(j, i, (j * width) + offsetX, (i * height) + offsetY, width, height, this._container));
            }
        }
      }*/
  }, {
    key: "updateGrid",
    value: function updateGrid() {
      var width = this.width;
      var height = this.height;
      for (var i = 0; i < this._rows; i++) {
        for (var j = 0; j < this._columns; j++) {
          this._cells[i][j].update(j, i, j * width, i * height, width, height);
        }
      }
    }
  }, {
    key: "width",
    get: function get() {
      return (_core.CORE.getState().config.screenSize.width - this._widthOffset) / this._columns;
    }
  }, {
    key: "height",
    get: function get() {
      return (_core.CORE.getState().config.screenSize.height - this._heightOffset) / this._rows;
    }
  }, {
    key: "getCell",
    value: function getCell(x, y) {
      return this._cells[y][x];
    }
  }, {
    key: "getCenterCell",
    value: function getCenterCell() {
      var mid = Math.round((this._cells.length - 1) / 2);
      var mid2 = Math.round((this._cells[0].length - 1) / 2);
      return this._cells[mid][mid2];
    }
  }]);
}();
var layoutManager = new LayoutManager();
var _default = exports["default"] = layoutManager;
//# sourceMappingURL=LayoutManager.js.map